import axios from 'axios'

import config from '../../config'

const deleteReminder = (params = {}) => {
  const { airportId, id } = params

  const url = `${config.baseUrl}/${airportId}/Reminders/${id}`
  return axios.delete(url)
}

export default deleteReminder
